import { useState } from "react";

export type CmtsReportFilters =
  Record<string, string>;

export function CmtsReportFilterPanel(props: {
  readonly onChange?:
    | ((filters: CmtsReportFilters) => void)
    | undefined;
}) {
  const [filters, setFilters] =
    useState<CmtsReportFilters>({});

  function update(
    key: string,
    value: string,
  ): void {
    const next = {
      ...filters,
    };

    if (value.trim()) {
      next[key] = value;
    } else {
      delete next[key];
    }

    setFilters(next);
    props.onChange?.(next);
  }

  function clear(): void {
    setFilters({});
    props.onChange?.({});
  }

  return (
    <div className="cmts-report-filter-grid">
      <label className="cmts-report-filter-field cmts-report-filter-field--search">
        <span>Search reports</span>

        <div className="cmts-report-search-input">
          <span aria-hidden="true">⌕</span>

          <input
            type="search"
            value={filters.search ?? ""}
            placeholder="Search by code, name or category..."
            onChange={(event) =>
              update(
                "search",
                event.currentTarget.value,
              )
            }
          />
        </div>
      </label>

      <label className="cmts-report-filter-field">
        <span>Date from</span>

        <input
          type="date"
          value={filters.dateFrom ?? ""}
          onChange={(event) =>
            update(
              "dateFrom",
              event.currentTarget.value,
            )
          }
        />
      </label>

      <label className="cmts-report-filter-field">
        <span>Date to</span>

        <input
          type="date"
          value={filters.dateTo ?? ""}
          onChange={(event) =>
            update(
              "dateTo",
              event.currentTarget.value,
            )
          }
        />
      </label>

      <button
        type="button"
        className="cmts-report-clear-button"
        disabled={Object.keys(filters).length === 0}
        onClick={clear}
      >
        Clear filters
      </button>
    </div>
  );
}